import { render } from "./ProviderComparisonModal.vue?vue&type=template&id=61491080&scoped=true"
import script from "./ProviderComparisonModal.vue?vue&type=script&lang=js"
export * from "./ProviderComparisonModal.vue?vue&type=script&lang=js"

import "./ProviderComparisonModal.vue?vue&type=style&index=0&id=61491080&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61491080"]])

export default __exports__